module.exports = __webpack_public_path__ + "img/trustly.ec6ee88.svg";